/* eslint-disable react/prop-types */
import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { SuccessText, ErrorText } from 'components/common/infoText/infoText';
import { serializeClasses } from 'utilities/css';
import { DescriptionDecorator } from './description';

export const Feedback = ({ content }) => (
  <div className="success-error-container" style={{ minHeight: '12px' }}>
    {content}
  </div>
);

export const SuccessDecorator = (Component) => (props) => {
  const { success, className, ...rest } = props;
  const classes = serializeClasses([className, success && 'success']);
  const content = !success ? null : <SuccessText text={success} />;
  return (
    <Fragment>
      <Component {...rest} className={classes} />
      <Feedback content={content} />
    </Fragment>
  );
};

export const ErrorDecorator = (Component) => {
  const DecoratedComponent = ({
    error, showError, className, ...rest
  }) => {
    const classes = serializeClasses([className, error && 'error']);
    const content = !error ? null : <ErrorText text={error} />;
    return (
      <Fragment>
        <Component {...rest} error={error} className={classes} />
        {showError && <Feedback content={content} />}
      </Fragment>
    );
  };
  DecoratedComponent.propTypes = {
    error: PropTypes.string,
    showError: PropTypes.bool,
    className: PropTypes.string,
  };

  DecoratedComponent.defaultProps = {
    error: undefined,
    showError: true,
    className: undefined,
  };
  return DecoratedComponent;
};

/**
 @todo figure out how to refactor ErrorOrSuccessDecorator
 implementation doesn't allow default props to perculate in
 at the Error/SuccessDecorator level
 */
// !!DEFAULT PROPS MUST BE DECLARED IN ARGS (see note below)
export const ErrorOrSuccessDecorator = (Component) => ({
  error,
  success,
  description,
  showError = true,
  showSuccess = true,
  hideDescriptionOnError = false,
  ...rest
}) => {
  if (description) {
    if (error && hideDescriptionOnError) {
      return ErrorDecorator(Component)({ ...rest, showError, error });
    }
    return DescriptionDecorator(Component)({ ...rest, description });
  }
  if (success) {
    return SuccessDecorator(Component)({ ...rest, showSuccess, success });
  }
  return ErrorDecorator(Component)({ ...rest, showError, error });
};

// Below causes component re-render on each update cycle
// export const ErrorOrSuccessDecorator = (Component) => ({
//   error,
//   success,
//   ...rest
// }) => {
//   const ErrorDecoratedComponent = ErrorDecorator(Component);
//   const SuccessDecoratedComponent = SuccessDecorator(Component);
//   if (success) {
//     return <SuccessDecoratedComponent success={success} {...rest} />;
//   }

//   return <ErrorDecoratedComponent error={error} {...rest} />;
// };
